import { useState } from 'react';
import type { StoreFilters } from '../lib/playerSupport';
import { PurchasesTable, SubscriptionsTable } from './StoreTables';

const PLAYER_PAGE_SIZE = 10;

/** The player detail's purchases and supporter passes (all environments; test ones are highlighted). */
export function PlayerStoreSection({ playerId }: { playerId: string }) {
  const filters: StoreFilters = { playerId, platform: '', environment: '', status: '' };
  const [purchaseOffset, setPurchaseOffset] = useState(0);
  const [subscriptionOffset, setSubscriptionOffset] = useState(0);
  return (
    <section className="rounded border-2 border-ink bg-white p-4 lg:col-span-2">
      <h2 className="font-semibold">Purchases</h2>
      <div className="mt-2">
        <PurchasesTable
          filters={filters}
          offset={purchaseOffset}
          onOffset={setPurchaseOffset}
          showPlayer={false}
          take={PLAYER_PAGE_SIZE}
        />
      </div>
      <h2 className="mt-4 font-semibold">Supporter pass</h2>
      <div className="mt-2">
        <SubscriptionsTable
          filters={filters}
          offset={subscriptionOffset}
          onOffset={setSubscriptionOffset}
          showPlayer={false}
          take={PLAYER_PAGE_SIZE}
        />
      </div>
    </section>
  );
}
